import { Col, Form, Row } from "antd";
import DocumentTitle from "react-document-title";
import { generatePath, useNavigate, useParams } from "react-router";
import MobileHeader from "../Components/MobileHeader";
import BackButton from "../Components/MobileHeader/BackButton";
import SaveButton from "../Components/MobileHeader/SaveButton";
import { RoutePaths } from "../routes";
import EditForm from "./Wishlist/EditForm";
import { useWishlist } from "../../data/hooks";
import { WishlistItem } from "../../data/types";
import Spin from "../Components/Spin";
import { analyticsLogEvent } from "../../data/firebase/analytics";

export default function WishEdit() {
  const { wishId, wishlistId } = useParams();
  const navigate = useNavigate();
  const [form] = Form.useForm();

  const { wishlist, updateWish } = useWishlist();
  const wish = wishlist?.items.find((w) => w.id === wishId);
  if (!wishId || !wishlistId || !wish) {
    return <Spin />;
  }

  const onSubmit = async (wish: WishlistItem) => {
    if (updateWish) await updateWish(wish);
    analyticsLogEvent("wish_edit", { wishlistId, wishId });
    navigate(generatePath(RoutePaths.wishlistItem, { wishlistId, wishId }));
  };

  return (
    <DocumentTitle title={`Wish editing`}>
      <>
        <MobileHeader title="Wish edit">
          <>
            <SaveButton onClick={() => form.submit()} />
            <BackButton />
          </>
        </MobileHeader>
        <Row justify={"center"}>
          <Col lg={14} sm={24}>
            <EditForm
              wishlistId={wishlistId}
              wish={wish}
              form={form}
              isLoading={!updateWish}
              onSubmit={onSubmit}
            />
          </Col>
        </Row>
      </>
    </DocumentTitle>
  );
}
